import React from 'react'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import Costs from '../../Costs'
import { InsertionFlowScreensProps } from '../../../../../../../@types/props-types'
import AdditionalCosts from '../../fields/additionalCosts/AdditionalCosts'
import Deposit from '../../fields/deposit/Deposit'
import FreeFrom from '../../fields/freeFrom/FreeFrom'
import CostCalculationBox from '../../../../../../common/display/costCalculationBox/CostCalculationBox'
import { PriceFieldType } from '../../../basicInfo/fields/priceField/PriceField'
import RentDuration from '../../fields/rentDuration/RentDuration'
import { DefaultRentPriceTypeOption } from '../../../../../../../@types/dropdown-types'
import CourtageGroup from '../../fields/courtageGroup/CourtageGroup'

export type CommercialAndResidentialCostsProps = {
  hasRentDuration?: boolean
  hasMoveInDate?: boolean
  screenTooltipKey?: string
  showCourtage?: boolean
}
const CommercialCostsRent: React.FC<
  InsertionFlowScreensProps<CostsScreenValidationResult> & CommercialAndResidentialCostsProps
> = ({ hasRentDuration, showCourtage, hasMoveInDate, ...props }) => {
  return (
    <Costs {...props}>
      {(costsWrapperProps) => (
        <div className='grid grid-flex'>
          <div className='grid-item palm-one-whole two-fifth'>
            <AdditionalCosts {...costsWrapperProps} />
            <Deposit {...costsWrapperProps} />
            {hasMoveInDate && <FreeFrom {...costsWrapperProps} />}
          </div>
          <div className='grid-item palm-one-whole three-fifth palm-margin-vertical-xl palm-padding-left-none padding-left-xl padding-top-m palm-margin-horizontal-xxl'>
            <CostCalculationBox
              additionalCostsValue={props.insertionData.additionalCosts}
              priceValue={props.insertionData.price}
              priceType={props.insertionData.priceType?.value as DefaultRentPriceTypeOption}
              priceFieldType={PriceFieldType.RENT_PRICE}
            />
          </div>
          <div className='grid-item one-whole' />
          {hasRentDuration && <RentDuration {...costsWrapperProps} />}
          {showCourtage && (
            <div className='grid-item one-whole margin-top-l'>
              <CourtageGroup {...costsWrapperProps} />
            </div>
          )}
        </div>
      )}
    </Costs>
  )
}

export default CommercialCostsRent
